export function LoaderIcon(): React.ReactElement {
  return (
    <>
      <style>
        {`
        .spinner {
          animation: Spin 2s infinite linear;
        }
        @keyframes Spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }`}
      </style>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.642"
        height="17.756"
        viewBox="0 0 16.642 17.756"
        display="block"
        className="spinner"
      >
        <g
          id="noun_loading_3402025"
          transform="matrix(-0.966, 0.259, -0.259, -0.966, 23.858, 18.075)"
        >
          <g
            id="Group_2702"
            data-name="Group 2702"
            transform="translate(4.98 12.111)"
          >
            <path
              id="Path_2400"
              data-name="Path 2400"
              d="M6.92,45.34a.97.97,0,1,0-.968.97A.97.97,0,0,0,6.92,45.34ZM7.7,48.248a.966.966,0,1,0,.1.735A.97.97,0,0,0,7.7,48.248Z"
              transform="translate(-4.98 -44.37)"
              fill="#0a0a0a"
              fillRule="evenodd"
            />
          </g>
          <g id="Loader" transform="translate(12.094 5)">
            <path
              id="Path_2401"
              data-name="Path 2401"
              d="M45.34,5a.97.97,0,1,0,.97.97A.97.97,0,0,0,45.34,5Zm3.878,1.034a.97.97,0,1,0,.355,1.323A.97.97,0,0,0,49.217,6.034Z"
              transform="translate(-44.37 -5)"
              fill="#bebebe"
              fillRule="evenodd"
            />
          </g>
          <g
            id="Loader-2"
            data-name="Loader"
            transform="translate(5.889 5.905)"
          >
            <path
              id="Path_2402"
              data-name="Path 2402"
              d="M11.712,12.87a.97.97,0,1,0,.353,1.325A.97.97,0,0,0,11.712,12.87Zm2.837-2.127a.97.97,0,1,0-.355,1.323A.97.97,0,0,0,14.549,10.743Z"
              transform="translate(-10.256 -10.256)"
              fill="#606060"
              fillRule="evenodd"
            />
          </g>
          <g
            id="Loader-3"
            data-name="Loader"
            transform="translate(8.537 18.15)"
          >
            <path
              id="Path_2403"
              data-name="Path 2403"
              d="M29.036,79.385a.968.968,0,1,0,.686.283A.97.97,0,0,0,29.036,79.385Zm-2.908-.78a.97.97,0,1,0,.355,1.325A.97.97,0,0,0,26.128,78.6Z"
              transform="translate(-24.673 -78.474)"
              fill="#0a0a0a"
              fillRule="evenodd"
            />
          </g>
          <g
            id="Loader-4"
            data-name="Loader"
            transform="translate(18.137 8.553)"
          >
            <path
              id="Path_2404"
              data-name="Path 2404"
              d="M80.3,25.159a.97.97,0,1,0-.355,1.325A.97.97,0,0,0,80.3,25.159Zm.069,2.908a.97.97,0,1,0,.965.97.97.97,0,0,0-.965-.97Z"
              transform="translate(-78.493 -24.674)"
              fill="#e6e6e6"
              fillRule="evenodd"
            />
          </g>
        </g>
      </svg>
    </>
  );
}
